export const BLOCK_WIDTH = 64;

export const HEIGHT = 43;
